import { X } from "lucide-react";
import { Player } from "@lottiefiles/react-lottie-player";
import emptyAnimation from "../../assets/empty.json";

export const ReviewsPanelContent = ({ closePanel, reviews }) => {
  return (
    <>
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div>
          <h2 className="text-xl font-bold text-gray-800">Reviews</h2>
          <p className="text-sm text-gray-500">Product reviews</p>
        </div>

        <button
          onClick={closePanel}
          className="p-2 hover:bg-gray-100 rounded-full"
        >
          <X size={20} />
        </button>
      </div>

      {/* Reviews or Empty State */}
      {reviews && reviews.length > 0 ? (
        <div className="space-y-3">
          {reviews.map((review, idx) => (
            <div
              key={idx}
              className="p-3 border rounded-xl bg-white shadow-sm"
            >
              <p className="font-medium text-gray-800">
                {review.name || "Anonymous"}
              </p>
              <p className="text-xs text-gray-500 mt-1">
                {review.comment} ★{review.rating}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center h-80">
          <Player
            autoplay
            loop
            src={emptyAnimation}
            style={{ height: "320px", width: "320px" }}
          />
          <p className="text-gray-500 mt-4 text-sm">
            No reviews yet!
          </p>
        </div>
      )}
    </>
  );
};
